module.exports = __webpack_public_path__ + "static/media/sex Harm.d38730f8.svg";